import { SET_USER, REMOVE_USER } from "./mutations";

const setUser = (payload) => ({
  type: SET_USER,
  payload,
});

const removeUser = () => ({
  type: REMOVE_USER,
});

export { setUser, removeUser };
